import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { BotStepListStore } from "../../store/BotStepListStore";

type BotStepListDialogsProps = {
  store: BotStepListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de BotStep.
 * Separado para mantener BotStepListPage más limpio.
 */
export const BotStepListDialogs: React.FC<BotStepListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  }
);
